import Money from './Money';
import type { CurrencyFormatterProps } from '../types';

const currencyFormat =
  ({ currency, locale }: { currency: string; locale: string }) =>
  ({
    number,
    onlyGreaterThanZero = false,
    round = true,
    forcedCurrency = currency,
  }: CurrencyFormatterProps) =>
    Money.getDollars(
      number,
      onlyGreaterThanZero,
      round,
      forcedCurrency,
      locale,
    );

export default currencyFormat;
